import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '@stores/store';
import pdfHeader from '../../assets/images/pdf-header.svg';
import pvxLogo from '../../assets/images/funding-header-logo.png';

const PdfHeader = () => {
  const userDetails = useSelector((state: RootState) => state?.UserData.user);

  return (
    <Box
      sx={{
        backgroundImage: `url(${pdfHeader})`,
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        borderRadius: '1.25rem',
        height: '8.5rem',
        display: 'flex',
        alignItems: 'center',
        padding: '2.5rem 1rem',
        justifyContent: 'space-between',
        marginBottom: '1.125rem',
      }}
    >
      <img src={pvxLogo} alt="PVX" style={{ height: '3.5rem' }} />
      <Box>
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 500,
            fontSize: '0.875rem',
            color: '#F6F8F9',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          {userDetails.username}
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 500,
            fontSize: '0.875rem',
            color: '#F6F8F9',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          {userDetails.email}
        </Typography>
      </Box>
    </Box>
  );
};

export default PdfHeader;
